module.exports = __webpack_public_path__ + "img/apex.eb93d30e.png";